import type { PropsWithChildren, ReactNode } from "react";

import { Heading } from "@radix-ui/themes";
import clsx from "clsx";

import { robotoCondensed } from "@/fonts";

export type TypoHeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;
export type TypoHeadingProps = PropsWithChildren<{
  readonly level: TypoHeadingLevel;
}>;

const sizeMap: Record<TypoHeadingLevel, "4" | "5" | "6" | "7" | "8" | "9"> = {
  1: "9",
  2: "8",
  3: "7",
  4: "6",
  5: "5",
  6: "4",
};

export function TypoHeading({ children, level }: TypoHeadingProps): ReactNode {
  return (
    <Heading
      as={`h${level}`}
      className={clsx(robotoCondensed.className, "font-bold-antialiased", {
        "my-2": level > 3,
        "my-3": level === 3,
        "my-4": level < 3,
      })}
      size={sizeMap[level]}
    >
      {children}
    </Heading>
  );
}
